import { Button } from '@/components/ui/button'
import { TagThumbnail } from '@/components/ui/tag-thumbnail'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { cn } from '@/lib/utils'
import { TRecruitment } from '@/types/page'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { JobDetailModal } from './job-detail-modal'

export const JobItem = ({ item }: { item: TRecruitment }) => {
  const t = useTranslations()
  let daysRemainingText = ''
  if (item.deadline) {
    const deadlineTime = new Date(item.deadline).getTime()
    // eslint-disable-next-line react-hooks/purity -- intentionally recompute "days remaining" against wall-clock time on every render; memoizing would freeze the countdown instead of reflecting elapsed time, changing behavior
    const currentTime = Date.now()
    const timeDifference = deadlineTime - currentTime

    if (timeDifference > 0) {
      // Calculate the number of days remaining
      const daysRemaining = Math.ceil(timeDifference / (1000 * 60 * 60 * 24))
      daysRemainingText = t(
        'landing_coolmate_101_page.recruitment.job_item.days_remaining',
        { days: daysRemaining }
      )
    } else {
      daysRemainingText = t(
        'landing_coolmate_101_page.recruitment.job_item.expired'
      )
    }
  }

  const isClose =
    daysRemainingText ===
      t('landing_coolmate_101_page.recruitment.job_item.expired') ||
    item?.closed

  return (
    <div className={'relative rounded-2xl bg-light p-5 pl-12'}>
      {isClose && (
        <div className='absolute left-1/2 top-1/2 z-10 -translate-x-1/2 -translate-y-1/2'>
          <Button size={'small'} variant={'black'}>
            {t('landing_coolmate_101_page.recruitment.job_item.job_done')}
          </Button>
        </div>
      )}
      <div
        className={
          'absolute -left-10 top-5 flex h-20 w-20 items-center justify-center rounded-2xl bg-warning-400'
        }
      >
        <Image
          src={ImageHelper.getImageUrl(item.image)}
          width={50}
          height={50}
          alt='icon-tuyen-dung'
        />
      </div>
      <div className={cn(isClose && 'opacity-50')}>
        <h4 className='text-lg font-medium text-neutral-900'>
          <TagThumbnail
            title={t('landing_coolmate_101_page.recruitment.job_item.new')}
            size={'small'}
            className='inline-flex'
          />
          {item.title}
        </h4>
        <p className='font-sans text-sm leading-5 text-neutral-900'>
          {item.benefits}
        </p>
        <div className='mt-1 flex items-center gap-1 font-sans text-xs text-neutral-900'>
          <IconClock />
          <p>{item.format}</p>
        </div>

        <div className='my-6 space-y-2'>
          <div className='line-clamp-1 rounded-md bg-neutral-100 px-5 py-1.5 text-xs text-neutral-900'>
            {t('landing_coolmate_101_page.recruitment.job_item.location_label')}
            : {item.address}
          </div>
          <div className='line-clamp-1 rounded-md bg-neutral-100 px-5 py-1.5 text-xs text-neutral-900'>
            {t('landing_coolmate_101_page.recruitment.job_item.salary_label')}:{' '}
            {item.salary}
          </div>
        </div>

        <div className='flex items-center justify-between'>
          <span className='text-xs text-primary'>{daysRemainingText}</span>
          {/* <button
          onClick={() => router.replace(jobUrl, { scroll: false })}
          className='text-xs text-primary hover:text-neutral-900'
        >
          {t('landing_coolmate_101_page.recruitment.job_item.details_and_apply')}{' '}
          <Image
            src={ImageHelper.getImageUrl(
              '/uploads/November2021/right-arrows(1).png'
            )}
            width={11}
            height={11}
            alt='arrow-right'
            className='inline'
          />
        </button> */}
          <JobDetailModal data={item} isClose={!!isClose} />
        </div>
      </div>
    </div>
  )
}

const IconClock = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 43 38' width={14}>
      <defs></defs>
      <title>Clock</title>
      <g id='Layer_2' data-name='Layer 2'>
        <g id='Layer_1-2' data-name='Layer 1'>
          <path
            fill='currentColor'
            d='M24.38,0A18.68,18.68,0,0,0,8,10h.36A5.65,5.65,0,0,1,12,11.28,14.43,14.43,0,0,1,24.38,4.17,14.7,14.7,0,0,1,38.92,19,14.72,14.72,0,0,1,24.38,33.87a14.42,14.42,0,0,1-8.26-2.61l-1.93,3.67A18.5,18.5,0,0,0,24.38,38,18.84,18.84,0,0,0,43,19,18.83,18.83,0,0,0,24.38,0Z'
          />
          <path
            fill='currentColor'
            d='M24.07,8A2.08,2.08,0,0,0,22,10.11v8.78A2.08,2.08,0,0,0,24.07,21h6.86a2.11,2.11,0,0,0,0-4.22H26.14V10.11A2.08,2.08,0,0,0,24.07,8Z'
          />
          <path
            fill='currentColor'
            d='M13.15,21.94l-2.89.44a.56.56,0,0,1-.63-.53V15.57a1.59,1.59,0,0,0-3-.76L.2,26.79a1.56,1.56,0,0,0,1.62,2.27l2.89-.44a.56.56,0,0,1,.63.53v6.28a1.59,1.59,0,0,0,3,.76l6.5-12a1.57,1.57,0,0,0-1.67-2.27Z'
          />
        </g>
      </g>
    </svg>
  )
}
